export default {
  OU_CODE: 50
}
